const generateSubtitle = (building) => {
  const neighborhoodName = building?.neighborhood?.name;
  const marketName = building?.market?.name;
  const submarketName = building?.submarket?.name;

  let subtitle = "";
  if (neighborhoodName && submarketName)
    subtitle = `${submarketName} (${neighborhoodName})`;

  if (submarketName && !neighborhoodName) subtitle = submarketName;

  if (neighborhoodName && !submarketName) subtitle = neighborhoodName;

  if (!submarketName && !neighborhoodName) subtitle = marketName || "";

  if (["New York", "Los Angeles"].includes(marketName))
    subtitle += ` - ${building.city}, ${building.state}`;
  return subtitle;
};

export default generateSubtitle;
